import.meta.glob(["../img/**"]);
import "./bootstrap";

import { createApp } from "vue";
import { createPinia } from "pinia";

import EntityType from "./components/EntityType.vue";
import FranchiseeSelector from "./components/FranchiseeSelector.vue";
import HousingType from "./components/HousingType.vue";
import InternationalPhone from "./components/InternationalPhone.vue";
import RegionalSelect from "./components/RegionalSelect.vue";

const app = createApp({});

import { i18nVue } from "laravel-vue-i18n";

app.use(i18nVue, {
    resolve: async (lang) => {
        const languages = import.meta.glob("../../lang/*.json");
        return await languages[`../../lang/${lang}.json`]();
    },
});

app.component("entity-type", EntityType);
app.component("franchisee-selector", FranchiseeSelector);
app.component("housing-type", HousingType);
app.component("international-phone", InternationalPhone);
app.component("regional-select", RegionalSelect);

app.use(createPinia());

app.mount("#app");
